export const UPDATE_LIVE_DATA = "[Live Bid] Update Live Data";
export const UPDATE_LIVE_BIDDING_RANK = "[Live Bid] Update Live Bidding Rank";
export const UPDATE_LIVE_EVENT_STATUS = "[Live Bid] Update Live Bidding Status (sucess , message and status code )";
